export default __webpack_public_path__ + "68993494ad041f0e8ccea17b584b389a.otf";